// ==========================================
// NEW SEARCH ARCHITECTURE - Phase 1
// index-loader.js
//
// Fetch/cache abstraction for a search index JSON file. This is a
// separate, independent loader from the one inside smart-search.js -
// it does not share state with it and does not touch its cache.
//
// Not wired into the site yet. Nothing calls this.
// ==========================================

(function (global) {
  "use strict";

  var NewSearch = (global.NewSearch = global.NewSearch || {});

  if (NewSearch.IndexLoader) {
    return;
  }

  /**
   * IndexLoader
   * Usage (future phases only):
   *   var loader = new NewSearch.IndexLoader({ url: "/assets/search-index-v2.json" });
   *   var index = await loader.load();
   */
  function IndexLoader(options) {
    options = options || {};
    this.url = options.url || null;
    this.timeoutMs = typeof options.timeoutMs === "number" ? options.timeoutMs : 1500;
    this._promise = null;
  }

  /**
   * Loads and caches the index. Subsequent calls return the same
   * in-flight/cached promise rather than re-fetching.
   */
  IndexLoader.prototype.load = function () {
    if (this._promise) return this._promise;

    if (!this.url) {
      this._promise = Promise.resolve([]);
      return this._promise;
    }

    this._promise = fetch(this.url)
      .then(function (res) {
        if (!res.ok) return [];
        return res.json();
      })
      .catch(function () {
        return [];
      });

    return this._promise;
  };

  /**
   * Loads with a timeout guard - resolves with `null` if the fetch
   * takes longer than timeoutMs, so callers can fall back gracefully
   * instead of blocking indefinitely.
   */
  IndexLoader.prototype.loadWithTimeout = function () {
    var timeoutMs = this.timeoutMs;
    return Promise.race([
      this.load(),
      new Promise(function (resolve) {
        setTimeout(function () {
          resolve(null);
        }, timeoutMs);
      }),
    ]);
  };

  /** Clears the cached promise, forcing the next load() to re-fetch. */
  IndexLoader.prototype.reset = function () {
    this._promise = null;
  };

  NewSearch.IndexLoader = IndexLoader;
})(window);
